import { HTTP } from "@/services/HTTPService";
import Vue from "vue";

export default {
  async updateWorkedMimkList() {
    try {
      await HTTP.get(`/redis_update_worked_mimk_list`);
      Vue.toasted.global.all_ok("Completed");
    } catch (err) {
      console.log(err);
    }
  },

  async updateWorkedM1List() {
    try {
      await HTTP.get(`/redis_update_worked_m1_list`);
      Vue.toasted.global.all_ok("Completed");
    } catch (err) {
      console.log(err);
    }
  },

  async updateSegments() {
    try {
      await HTTP.get(`/redis_refresh_segments`);
      Vue.toasted.global.all_ok("Completed");
    } catch (err) {
      console.log(err);
    }
  },
  async getMimkList(segment) {
    try {
      const response = await HTTP.get(`/mimk/?segment=${segment}`);
      return response.data;
    } catch (error) {
      console.error("Ошибка при получении списка мимков:", error);
      throw error;
    }
  },

  async updateMimkRating(mimk_id, rating, segment) {
    try {
      const response = await HTTP.patch(`/mimk/${mimk_id}?segment=${segment}`, { rating });
      Vue.toasted.global.all_ok("Completed");
      return response.data;
    } catch (error) {
      console.error("Ошибка при обновлении рейтинга:", error);
      Vue.toasted.global.error("Error");
      throw error;
    }
  },
};
